<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
    <v-card flat>
      <v-toolbar style="color: white" color="secondary">
        <h3>Prozess für Prozesssteckbrief auswählen</h3>
        <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" color="primary">
            mdi-information
          </v-icon>
        </template>
        <span>Es werden nur Prozesse ohne Prozesssteckbrief zur Auswahl angezeigt</span>
      </v-tooltip>
        <v-spacer></v-spacer>
        <v-toolbar-items class="mt-6">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <div class="columns" id="columns">
      <v-card flat class="column is-one-quarter border-right">
        <v-subheader >Verfügbare Prozesse:</v-subheader>
        <v-list class="listFrame">
        <template v-for="(item, index) in processes">

        <v-list-item
          @click="itemSelected(item)"
          :key="index"
          :class="{ 'custom-active': selectedItem && selectedItem.uuid == item.uuid }"

        >
          <v-list-item-content class="list-item">
            <v-list-item-title class="text-wrap">
              <span class="font-m">{{ item.fileName }}</span>
              <span class="date float-right mt-1">{{item.creationDate | moment("DD.MM.YYYY HH:mm")}}</span>
            </v-list-item-title>
            <v-list-item-subtitle v-if="currentConnectedModel && currentConnectedModel == item.uuid"><v-chip outlined color="primary">Aktuell verknüpft</v-chip></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="index" />
        </template>
        </v-list>
      </v-card>
    <div class="column">
      <div id="viewerFrame" v-if="selectedItem != null">
        <BpmnViewer v-if="loaded" ref="bpmnViewer" :diagramXML="selectedProcessXML"/>  
      </div>
      <div v-else>
        <p v-if="processes.length == 0" class="text-gray mt-10"
           style="text-align-last: center; margin: 10px; font-size:0.8rem;">Es sind keine Prozesse verfügbar</p>
        <p v-else class="text-gray mt-10" style="text-align-last: center; margin: 10px; font-size:0.8rem;">Prozess
          auswählen um
          Vorschau
          anzuzeigen</p>
      </div>
    </div>
  </div>
      <div id="footer" class="bg-gray pr-6">
          <v-btn elevation="0" style="float:right;" color="primary" @click="chooseProcess">
            Verknüpfen
          </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import processModelingService from "@/pages/ProcessModeling/process-modeling-service.js";
import BpmnViewer from "@/pages/ProcessModeling/BpmnViewer";
import ConfirmDialog from "@/components/common/ConfirmDialog";
import InfoDialog from "@/components/common/InfoDialog";

export default {
  components: {
    BpmnViewer,
    ConfirmDialog,
    InfoDialog
  },
  props: {
    value: Boolean,
    uuid: {
      required: true,
      type: String
    },
    fileName: String,
    commit: Object
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    userId() {
      return this.$store.getters.user.username;
    }
  },
  data() {
    return {
      loaded: false,
      dialog:false,
      resolve: null,
      reject: null,
      processes: [],
      selectedItem: {uuid: null},
      selectedProcessXML: null,
      currentConnectedModel: null,
    };
  },
  methods: {
    open(connectedModelId, characteristicId = null){
      processModelingService.getAllFilesForProcessCharacteristic().then(res => {
        this.processes = res.data;
        if(characteristicId) this.processes = this.processes.filter(elem => elem.characteristic == null || elem.characteristic.id == characteristicId)
          if(connectedModelId){
            this.currentConnectedModel = connectedModelId;
            this.itemSelected(this.processes.find(elem => elem.uuid == connectedModelId))
          }
        this.dialog=true;
      })
  
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    close(){
      this.dialog = false;
      this.resetData();
      this.reject(this.selectedItem);
    },
    chooseProcess(){
      this.dialog = false;
      this.resolve(this.selectedItem)
      this.resetData();
    },
    resetData(){
      this.processes = [];
      this.selectedItem = null;
      this.selectedProcessXML = null;
    },
    itemSelected(item){
      this.selectedItem = item;
      this.loaded = false;
      processModelingService.getProcessXml(item.uuid).then(res => {
        this.selectedProcessXML = res.data;
        this.loaded = true;
      })
    },
    showConfirmDialog() {
      processModelingService
        .retrieveModelInformation(this.uuid)
        .then(async result => {
          if (
            result.data.currentEditor &&
            result.data.currentEditor !== this.userId
          ) {
            const currentEditor = result.data.currentEditor;
            const infoMessage =
              "Die Version kann nicht übernommen werden, da folgender Nutzer gerade das Prozessmodell bearbeitet: " +
              currentEditor;
            this.$refs.infoDialog.open(
              "Bearbeitung nicht möglich",
              infoMessage
            );
          } else {
            this.revert().then(() => {
              this.$emit("changed");
              this.show = false;
            });
          }
        });
    }
  }
};
</script>

<style scoped>
#viewerFrame{
  position: absolute;
  right: 0;
  left: 25% !important;
  bottom: 0;
  top:0;

}
#columns{
  margin:0;
  position:absolute;
  height: calc(100% - (2*64px));
  width:100%;
}
.dialog {
  flex-grow: 0;
  padding: 20px;
  background-color: #fff;
}
.description{
  display:inline-block;
  width: calc(60% - 5px);
  height: 400px;
  margin: 15px 5px 0 0;
}
.modelList{
  display:inline-block;
  width: calc(40% - 15px);
  height: 400px;
  margin: 5px 0 0 15px;
  border-left: 2px solid var(--v-primary-base);
}
.elementDivider{

  margin: 1px;
  border: 0.5px solid var(--v-primary-base);
}
#footer{
  position: absolute;
  width:100%;
  bottom: 0;
  padding:10px;
  height:64px;
}
.listFrame{
  max-height: calc(100% - 44px);
  overflow-y: auto;
}
.custom-active {
  background-color: #f5f5f5;
}

</style>
